<template>
  <div>
    <section style="margin-top: -64px">
      <v-parallax
        class="si-hero-parallax"
        dark
        :height="heroHeight"
        :src="require('@/assets/background_2.svg')"
      >
        <v-container
          grid-list-lg
          fill-height
          fluid
          :style="`background-color: rgb(0 0 0 / 20%); background:linear-gradient(to ${
            $vuetify.breakpoint.xsOnly ? 'top' : 'right'
          }, rgb(0 0 0 / 50%) 30%, rgb(0 0 0 / 0%)`"
        >
          <v-layout
            justify-center
            align-center
            fill-height
          >
            <v-flex
              xs12
              md10
              lg9
              xl7
              mx-auto
            >
              <v-layout
                wrap
                align-center
              >
                <v-flex
                  xs12
                  md7
                  class="white--text order-md-1 order-2"
                >
                  <div class="text-h3 text-sm-h2 font-weight-light">
                    Powerful <br>Online <br>
                    Superannuation Calculators
                  </div>
                  <div
                    style="background-color: white; height: 2px"
                    class="my-4"
                  />
                  <div class="title font-weight-light">
                    Instant, compliant superannuation calculations at your
                    fingertips, powered by world-class technology
                  </div>
                </v-flex>
                <v-flex
                  xs12
                  md5
                  class="mt-16 mt-md-0 px-4 order-md-2 order-1"
                >
                  <v-responsive
                    class="si-hero-image mx-auto"
                    :aspect-ratio="1"
                    :max-width="$vuetify.breakpoint.smAndDown ? 350 : 500"
                  >
                    <div
                      class="si-hero-image-hover-handler"
                      @mouseover="heroImageHover = true"
                      @mouseleave="heroImageHover = false"
                    />
                    <div
                      v-scroll="handleScroll"
                      class="si-hero-image-container"
                    >
                      <img
                        :src="`${require('@/assets/report.png')}`"
                        :style="`top: ${reportTop}%; ${
                          heroImageResetting
                            ? 'transition: all 0.5s ease 0s'
                            : ''
                        }`"
                      >
                    </div>
                    <img
                      class="si-hero-image-top"
                      :src="`${require('@/assets/computer.svg')}`"
                      style="height: 100%; width: 100%"
                    >
                  </v-responsive>
                  <!-- <v-responsive class="si-hero-image mx-auto" :aspect-ratio="1" :max-width="$vuetify.breakpoint.smAndDown ? 350 : 500 " >
                        <div class="si-hero-image-hover-handler"></div>
                        <div class="si-hero-image-container">
                          <img :src="`${require('@/assets/report.png')}`" :style="`top: ${reportTop}%; ${heroImageResetting ? 'transition: all 0.5s ease 0s' : ''}`"/>
                        </div>
                        <img class="si-hero-image-top" :src="`${require('@/assets/computer.svg')}`" style="height: 100%; width: 100%"/>
                      </v-responsive> -->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-parallax>
    </section>

    <HomeServices />

    <section>
      <v-container
        grid-list-xl
        fluid
        py-8
        my-8
      >
        <v-layout
          wrap
          justify-center
        >
          <v-flex
            xs12
            md10
            lg9
            xl7
            mx-auto
          >
            <v-layout wrap>
              <v-flex
                xs12
                class="display-2 my-4 font-weight-light"
              >
                Calculators
                <v-progress-linear
                  :indeterminate="true"
                  :active="_loader"
                  height="2"
                />
              </v-flex>
              <template v-for="(group, category) in calculators">
                <v-flex
                  :key="category"
                  xs12
                  class="body-2 font-weight-bold grey--text"
                >
                  <span v-if="category !== '_none'">{{ category }}</span>
                  <span
                    v-else
                    class="font-italicx"
                  >Other</span>
                </v-flex>
                <v-flex
                  v-for="calculator in group"
                  :key="`${calculator.cid}_${calculator.vid}`"
                  xs12
                  md6
                >
                  <SiProductCard :product="calculator" />
                </v-flex>
              </template>
              <v-flex
                xs12
                class="body-2 font-weight-bold grey--text"
              >
                Request a Calculator
              </v-flex>
              <v-flex
                xs12
                md6
              >
                <!-- <v-hover v-slot:default="{ hover }"> -->
                <v-card
                  outlined
                  class="cursor-pointer"
                  @click="dialog = true"
                >
                  <v-responsive :height="225">
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                    >
                      <v-flex shrink>
                        <v-flex
                          xs12
                          text-center
                          pa-0
                        >
                          <v-icon x-large>
                            loupe
                          </v-icon>
                        </v-flex>
                        <v-flex
                          xs12
                          text-center
                          class="title font-weight-light grey--text"
                        >
                          Request a calculator
                        </v-flex>
                        <v-flex
                          xs8
                          mx-auto
                          pa-0
                          text-center
                          class="caption grey--text"
                        >
                          We are constantly automating new financial tools and
                          calculators. If you have one that you would find
                          helpful, let us know and will take a look.
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-responsive>
                  <v-card-actions class="pa-4">
                    <v-spacer />
                    <v-btn
                      text
                      color="teal"
                    >
                      Request
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <!-- </v-hover> -->
              </v-flex>
              <v-flex mt-8>
                <si-testimonials display-group-name="home" />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>


    <!-- <v-parallax
      height="450"
      :src="`${productionAppUrl}${require('@/assets/computer_user.jpg')}`"
    >
      <v-overlay absolute></v-overlay>
      <v-container grid-list-xl fluid style="z-index: 6" class="white--text">
        <v-layout wrap>
          <v-flex xs12 md10 lg8 mx-auto>
            <v-layout wrap>
              <v-flex xs12 md8 class="display-2 white--text font-weight-light">
                Super Info Assist
              </v-flex>
              <v-flex xs12 md8>
                For a small fee you can have one of the Super Info experts
                perform your calculation on your behalf. We verify you have the
                necessary information and ensure your calculation is performed
                using the correct method.
                <br />
                <span class="caption"
                  >Only available for eligible calculations</span
                >
              </v-flex>
              <v-flex xs12>
                <v-btn depressed large color="primary" to="/assistance"
                  >Get started <v-icon right>arrow_forward</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-parallax> -->

    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <v-layout align-center>
            <v-icon left>
              loupe
            </v-icon>
            <span class="headline">Request a calculator</span>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <SiInputText
                    v-model="suggestion.caption"
                    label="Short description"
                    filled
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <SiInputTextarea
                    v-model="suggestion.description"
                    label="Detailed description"
                    filled
                    required
                    hint="Describe your tool in detail, what would you like it to do, how would you use it? "
                  />
                </v-flex>
                <v-flex xs12>
                  <SiInputText
                    v-model="suggestion.email"
                    label="Email (optional but we might like to chat)"
                    filled
                    hint="We might like to contact you to discuss your idea. Your email will not be used for any other purpose"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="closeMe"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="submitSuggestion"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="thankyou"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Thank you!
        </v-card-title>
        <v-card-text>
          Thank you for suggesting a calculator. We will take a look at your
          suggestion and see if it something we can build.
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            text
            @click="thankyou = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import clientPath from "@/plugins/client-path";
import { rtdb } from "@/plugins/firebase";
import { forEach } from "lodash";
import helpers from "@/mixins/helpers";
import renderReady from "@/mixins/render-ready";

export default {
  mixins: [helpers, renderReady],
  data() {
    return {
      item: null,
      dialog: false,
      thankyou: false,
      files: {},
      calculator: {},
      suggestion: {},
      fields: {},
      reportTop: 5,
      heroHeight: 830,
      heroImageHover: false,
      heroImageInterval: null,
      heroImageResetting: false,
      renderWhen: { _loader: false },
    };
  },
  computed: {
    ...mapGetters(["_calculators", "_loader", "_pageLayout"]),
    calculators() {
      let calcs = {};
      forEach(this._sortObject(this._calculators, "category"), (c) => {
        if (!calcs[c.category]) calcs[c.category || "_none"] = [];
        forEach(this._sortObject(c.variants), (v) => {
          if (!c._disabled && !v._disabled)
            calcs[c.category || "_none"].push({
              ...v,
              ...{ cid: c.id, vid: v.id, image: c.image },
            });
        });
      });
      forEach(calcs, (c, id) => {
        if (c.length === 0) delete calcs[id];
      });
      return calcs;
    },
    productionAppUrl() {
      return process.env.VUE_APP_BASE_URL_PROD;
    },
  },
  watch: {
    heroImageHover(v) {
      if (v) {
        this.heroImageResetting = false;
        this.reportTop = 5;
        this.heroImageInterval = setInterval(() => {
          let top = Math.max(-215, this.reportTop - 1);
          this.reportTop = top;
        }, 10);
      } else {
        if (this.heroImageInterval) clearInterval(this.heroImageInterval);
        this.reportTop = 5;
        this.heroImageResetting = true;
        setTimeout(() => (this.heroImageResetting = false), 500);
      }
    },
  },
  mounted() {
    clientPath.track("view_homepage");
  },
  methods: {
    closeMe() {
      this.dialog = false;
      this.suggestion = {};
    },
    submitSuggestion() {
      if (!this.$refs.form.validate()) return;
      rtdb
        .ref(`feedback/suggestions`)
        .push({ ...this.suggestion, ...{ timestamp: Number(new Date()) } });
      this.dialog = false;
      this.thankyou = true;
      this.suggestion = {};
    },
    handleScroll() {
      this.heroImageResetting = false;
      this.reportTop =
        (document.documentElement.scrollTop / this.heroHeight) * -200 + 5;
    },
  },
};
</script>

<style media="screen" lang="scss">
.si-hero-parallax .v-parallax__content {
  padding: 0;
}
.si-hero-image-container,
.si-hero-image-hover-handler {
  background-color: rgb(231, 231, 231);
  height: 50.55%;
  width: 87.3%;
  position: absolute;
  top: 10%;
  left: 6%;
  z-index: 0;
  overflow: hidden;

  img {
    width: 80%;
    position: absolute;
    left: 10%;
    top: 5%;
  }
}
.si-hero-image-hover-handler {
  z-index: 3 !important;
  background-color: transparent !important;
}
.si-hero-image-top {
  height: 100%;
  width: 100%;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
}
.si-header {
  background: url(../assets/bg-pattern.png),
    linear-gradient(to left, #40508b, #25a9c1);
}
</style>
